<template>
    <div
        class="home"
        :class="{ card: isSinglePage }"
        :style="{
            backgroundImage: bgUrl ? 'url(' + bgUrl + ')' : '',
            backgroundRepeat: bgUrl ? 'no-repeat' : 'repeat-x',
            backgroundSize: bgUrl ? '10rem' : ''
        }"
    >
        <LoginForm ref="loginform" @on-success="handleWapLoginSuccess"></LoginForm>
        <!-- <Header /> -->
        <div style="position: relative" v-if="isShowQuestionBoard">
            <Title></Title>
            <ProgressBar />
            <div v-for="(q, index) in questions" :key="q.id">
                <RadioGroup
                    v-if="q.questionType === QuestionType.single && q.show === true"
                    :all="questionNumber"
                    :current="firstToCurrentPageQuestionNumber + index + 1"
                    :title="q.questionStem"
                    :desc="q.desc"
                    :options="q.questionOptions"
                    :require="q.requireFlag"
                    :id="q.qidentifier"
                    v-model="q.anwser"
                    :question="q"
                    @on-change="handleRadioGroupChange($event, q)"
                >
                </RadioGroup>
                <MultiRadioGroup
                    v-if="q.questionType === QuestionType.multi && q.show === true"
                    :all="questionNumber"
                    :current="firstToCurrentPageQuestionNumber + index + 1"
                    :title="q.questionStem"
                    :desc="q.desc"
                    :options="q.questionOptions"
                    :require="q.requireFlag"
                    :id="q.qidentifier"
                    v-model="q.anwser"
                    :question="q"
                    @on-change="handleMultiRadioGroupChange($event, q)"
                />
                <FillBlank
                    v-if="q.questionType === QuestionType.fillblank && q.show === true"
                    :all="questionNumber"
                    :current="firstToCurrentPageQuestionNumber + index + 1"
                    :title="q.questionStem"
                    :desc="q.desc"
                    :require="q.requireFlag"
                    :id="q.qidentifier"
                    v-model="q.anwser"
                    :question="q"
                    @on-change="handleFillBlankChange($event, q)"
                />
            </div>
            <PageStep />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { setAuthCookies, removeAuthCookies } from '@/libs/auth-cookie';
// import { getLoginInfo, performNativeLogin, closeWebView } from '@eastmoney/utils';
import { getLoginInfo, performNativeLogin, closeWebView } from '@eastmoney/mku';
import { Dialog } from 'vant';
import { displayToEnd, checkRelConfigQuestion, checkAnswer } from '@/libs/question-tool';
import {
    CHANGE_DISPLAY_QUESTION,
    CHANGE_PASS_VALIDATE,
    CHANGE_QUESTIONNAIRE_CODE,
    CHANGE_JUMP_QIDENTIFIER,
    CHANGE_JUMP_TO_END_FLAG,
    CHANGE_PAGE
} from '@/libs/constant';
import { QuestionType, FullTopMode, QuestionSepcialFlag } from '@/libs/enum';
import browser from '@/libs/browser';
import { setPageFullTopMode } from '@/libs/native';
// import Header from './components/Header';
import Title from './components/Title.vue';
import RadioGroup from './components/RadioGroup.vue';
import MultiRadioGroup from './components/MultiRadioGroup.vue';
import FillBlank from './components/FillBlank.vue';
import PageStep from './components/PageStep.vue';
import LoginForm from './components/LoginForm.vue';
import ProgressBar from './components/ProgressBar.vue';
import bgIcon from '@/assets/images/bg-icons.png';
import { isEastmoneyDomain } from '@/libs/tool';

export default {
    name: 'home',
    components: {
        // Header,
        Title,
        RadioGroup,
        MultiRadioGroup,
        FillBlank,
        PageStep,
        LoginForm,
        ProgressBar
    },
    computed: {
        ...mapGetters([
            'questionNumber',
            'firstToCurrentPageQuestionNumber',
            'hasGetQuestionnaire'
        ]),
        ...mapState([
            'isSinglePage',
            'page',
            'currentPage',
            'needLogin',
            'questionFail',
            'pictureConfig'
        ]),
        questions() {
            return (
                this.$store.state.displayQuestions &&
                this.$store.state.displayQuestions.filter(q => q.show)
            );
        },
        isShowQuestionBoard() {
            return !this.isShowLogin && !this.questionFail;
            // && this.questions && this.questions.length;
        },
        isJumpToEnd() {
            return this.$store.state.jumpToEndFlag;
        },
        bgUrl() {
            return this.pictureConfig.h5Bg;
        }
    },
    data() {
        return {
            QuestionType,
            isShowLogin: false,
            bgIcon
        };
    },
    methods: {
        restoreQuestionStatus() {
            this.$store.commit(CHANGE_PASS_VALIDATE, null);
            this.$store.commit(CHANGE_JUMP_TO_END_FLAG, false);
            const { jumpQidentifierCollect } = this.$store.state;
            const newJumpQidCollect = { ...jumpQidentifierCollect };
            for (let i = this.currentPage; i <= Object.keys(this.page).length; i++) {
                if (newJumpQidCollect[Number(i).toString()]) {
                    newJumpQidCollect[Number(i).toString()] = null;
                }
            }
            this.$store.commit(CHANGE_JUMP_QIDENTIFIER, newJumpQidCollect);
        },
        async handleRadioGroupChange(anwser, question) {
            this.restoreQuestionStatus();
            const group = displayToEnd(this.page, this.currentPage, question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, group);
            this.$store.commit(CHANGE_PAGE, { ...this.page });
            // 收集后续问题的依赖关系，逆向判断有关联关系的题目是否应该显示
            const checkgroup = checkRelConfigQuestion(question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, checkgroup);
            const displayGroup = checkAnswer(this.currentPage, question.qidentifier);
            if (displayGroup === QuestionSepcialFlag.submitInvalid) {
                this.submitInvalid(question, anwser);
                return;
            }
            this.$store.commit(CHANGE_DISPLAY_QUESTION, displayGroup);
        },
        handleMultiRadioGroupChange(anwser, question) {
            this.restoreQuestionStatus();
            const group = displayToEnd(this.page, this.currentPage, question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, group);
            this.$store.commit(CHANGE_PAGE, { ...this.page });
            // 收集后续问题的依赖关系，逆向判断有关联关系的题目是否应该显示
            const checkgroup = checkRelConfigQuestion(question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, checkgroup);
            const displayGroup = checkAnswer(this.currentPage, question.qidentifier);
            if (displayGroup === QuestionSepcialFlag.submitInvalid) {
                this.submitInvalid(question, anwser);
                return;
            }
            this.$store.commit(CHANGE_DISPLAY_QUESTION, displayGroup);
        },
        handleFillBlankChange(answer, question) {
            this.restoreQuestionStatus();
            const group = displayToEnd(this.page, this.currentPage, question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, group);
            this.$store.commit(CHANGE_PAGE, { ...this.page });

            // 收集后续问题的依赖关系，逆向判断有关联关系的题目是否应该显示
            const checkgroup = checkRelConfigQuestion(question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, checkgroup);
            const displayGroup = checkAnswer(this.currentPage, question.qidentifier);
            this.$store.commit(CHANGE_DISPLAY_QUESTION, displayGroup);
        },
        async submitInvalid(question, anwser) {
            const qidentifier = question.qidentifier;
            console.log('提交为无效答卷');
            const questionAnswer = {
                qidentifier,
                optionAnswers: [{ optionIdentifier: anwser }]
            };
            // 对多选题
            if (question.questionType === QuestionType.multi) {
                questionAnswer.optionAnswers = anwser.map(id => ({ optionIdentifier: id }));
            }
            const isRes = await this.$store.dispatch('submitInvalidQuestionnaire', questionAnswer);
            if (isRes) {
                this.jumpNextPage();
            }
        },
        jumpNextPage() {
            const { questionnaireCode, secaccount } = this.$store.state;
            // this.$toast(submitText || '提交成功');
            this.$router.replace({
                path: '/end',
                query: {
                    code: questionnaireCode,
                    secaccount
                }
            });
        },
        async initQuestionnaire() {
            try {
                // 已经获取到问卷配置了
                if (this.hasGetQuestionnaire) {
                    return;
                }
                // 以Home作为入口页
                const { code } = this.$route.params;
                if (code) {
                    this.$store.commit(CHANGE_QUESTIONNAIRE_CODE, code);
                    await this.$store.dispatch('getQuestionConfig', code);
                    this.$trackLaunch(this.$store.state.questionnaireCode);
                    if (!this.hasGetQuestionnaire) {
                        await this.initLogin();
                    }
                } else {
                    this.$toast('当前页面地址不存在问卷代码');
                }
            } catch (error) {
                console.log(error);
            }
        },
        initLogin() {
            // 不需要登录
            if (!this.needLogin) {
                return;
            }
            // 主包内需要登录
            if (browser.isApp()) {
                this.handleAppLogin();
                return;
            }
            // 主域名下，跳转到通行证登录页，并设置 backurl 为当前页面地址
            if (isEastmoneyDomain()) {
                // test: https://mpassportuat2.eastmoney.com
                const loginUrl = `https://mpassport.eastmoney.com/login?backurl=${encodeURIComponent(
                    window.location.href
                )}`;
                window.location.replace(loginUrl);
                return;
            }
            this.isShowLogin = true;
            this.$refs.loginform.show();
        },
        performAppLogin() {
            performNativeLogin(
                async res => {
                    const { ct, ut, uid } = res.data;
                    setAuthCookies({ ct, ut, uid });
                    const { code } = this.$route.params;
                    await this.$store.dispatch('getQuestionConfig', code);
                    this.checkQuestion();
                },
                () => {
                    console.log('登录失败');
                    closeWebView();
                }
            );
        },
        checkQuestion() {
            // 1. 已登陆且接口未返回题目的情况（接口逻辑问题） 2. 未登录没题目（ct，ut过期，尝试重新登录后依然无法获取题目）
            if (!this.questionFail && (!this.questions || this.questions.length === 0)) {
                Dialog({
                    title: '温馨提示',
                    // message: '登录校验未通过，请重新登录后再回来试试~',
                    message: '当前登录信息已失效，将重新登录',
                    confirmButtonText: '好的'
                }).then(() => {
                    this.performAppLogin();
                });
            }
        },
        handleAppLogin() {
            getLoginInfo(
                async res => {
                    const { ct, ut } = res.data;
                    setAuthCookies({ ct, ut });
                    const { code } = this.$route.params;
                    await this.$store.dispatch('getQuestionConfig', code);
                    // console.info('从app中获取的ct ut：', ct, ut);
                    this.checkQuestion();
                },
                () => {
                    this.performAppLogin();
                }
            );
        },
        handleWapLoginSuccess() {
            const { code } = this.$route.params;
            if (code) {
                this.$store.commit(CHANGE_QUESTIONNAIRE_CODE, code);
                this.$store.dispatch('getQuestionConfig', code);
                this.isShowLogin = false;
            } else {
                this.$toast('当前页面地址不存在问卷代码');
            }
        },
        initAppInfo() {
            return new Promise((resolve, reject) => {
                if (browser.isApp()) {
                    removeAuthCookies();
                    getLoginInfo(
                        res => {
                            const { ct, ut, uid } = res.data;
                            setAuthCookies({ ct, ut, uid });
                            resolve();
                        },
                        () => {
                            reject();
                        }
                    );
                } else {
                    resolve();
                }
            });
        }
    },
    async mounted() {
        /** 线上bug修复，在app端，无论后端配置是否需要登录，都需要将ct，ut传给服务端，没有则为空 */
        try {
            await this.initAppInfo();
        } catch (error) {
            console.warn('initAppInfo failed:', error);
        }
        // console.info('cookies: ', document.cookie);
        this.initQuestionnaire();
        setPageFullTopMode(FullTopMode.normal);

        // 这是为了方便抽奖开发的测试代码，后续需要删除
        // if (this.$route.name !== 'end') {
        // 	this.$router.push({
        // 		name: 'end',
        // 		query: { code: 'If0rbb' }
        // 	})
        // }
    }
};
</script>
<style lang="scss" scoped>
@import './Home.scss';
</style>
